import {
  prefectureOptions
} from '../../../const';
export type InputData = {
  [key: string]: string,
}
export const initialInputData: InputData = {
  firstName: "",
  lastName: "",
  firstNameKana: "",
  lastNameKana: "",
  zip: "",
  prefecture: "",
  city: "",
  townAndNumber: "",
  building: "",
  tel: "",
  email: "",
  password: "",
  passwordConfirm: "",
}
export type InputDataConfig = {
  [key: string]: {
    name: string,
    type: string,
    options?: {value: string, label: string}[],
    placeholder?: string,
    required?: boolean,
    caution?: string,
    pattern?: RegExp,
    invalidMsg?: string,
  }
}

export const inputDataConfig: InputDataConfig = {  
  lastName: {
    name: "お名前[姓]",
    type: "text",
    placeholder: "例) 山田",
    required: true,
  },
  firstName: {
    name: "お名前 [名]",
    type: "text",
    placeholder: "例) 太郎",
    required: true,
  },
  lastNameKana: {
    name: "お名前(かな) [姓]",
    type: "text",
    placeholder: "例) やまだ",
    required: true,
  },
  firstNameKana: {
    name: "お名前(かな) [名]",
    type: "text",
    placeholder: "例) たろう",
    required: true,
  },
  zip: {
    name: "郵便番号(ハイフン抜き)",
    type: "text",
    placeholder: "例) 8120012",
    required: true,
    pattern: /^\d{7}$/,
  },
  prefecture: {
    name: "都道府県",
    type: "select",
    options: 
    [
      {"value": "", "label": "選択してください"},
      {"value": "北海道", "label": "北海道"},
      {"value": "青森県", "label": "青森県"},
      {"value": "岩手県", "label": "岩手県"},
      {"value": "宮城県", "label": "宮城県"},
      {"value": "秋田県", "label": "秋田県"},
      {"value": "山形県", "label": "山形県"},
      {"value": "福島県", "label": "福島県"},
      {"value": "茨城県", "label": "茨城県"},
      {"value": "栃木県", "label": "栃木県"},
      {"value": "群馬県", "label": "群馬県"},
      {"value": "埼玉県", "label": "埼玉県"},
      {"value": "千葉県", "label": "千葉県"},
      {"value": "東京都", "label": "東京都"},
      {"value": "神奈川県", "label": "神奈川県"},
      {"value": "新潟県", "label": "新潟県"},
      {"value": "富山県", "label": "富山県"},
      {"value": "石川県", "label": "石川県"},
      {"value": "福井県", "label": "福井県"},
      {"value": "山梨県", "label": "山梨県"},
      {"value": "長野県", "label": "長野県"},
      {"value": "岐阜県", "label": "岐阜県"},
      {"value": "静岡県", "label": "静岡県"},
      {"value": "愛知県", "label": "愛知県"},
      {"value": "三重県", "label": "三重県"},
      {"value": "滋賀県", "label": "滋賀県"},
      {"value": "京都府", "label": "京都府"},
      {"value": "大阪府", "label": "大阪府"},
      {"value": "兵庫県", "label": "兵庫県"},
      {"value": "奈良県", "label": "奈良県"},
      {"value": "和歌山県", "label": "和歌山県"},
      {"value": "鳥取県", "label": "鳥取県"},
      {"value": "島根県", "label": "島根県"},
      {"value": "岡山県", "label": "岡山県"},
      {"value": "広島県", "label": "広島県"},
      {"value": "山口県", "label": "山口県"},
      {"value": "徳島県", "label": "徳島県"},
      {"value": "香川県", "label": "香川県"},
      {"value": "愛媛県", "label": "愛媛県"},
      {"value": "高知県", "label": "高知県"},
      {"value": "福岡県", "label": "福岡県"},
      {"value": "佐賀県", "label": "佐賀県"},
      {"value": "長崎県", "label": "長崎県"},
      {"value": "熊本県", "label": "熊本県"},
      {"value": "大分県", "label": "大分県"},
      {"value": "宮崎県", "label": "宮崎県"},
      {"value": "鹿児島県", "label": "鹿児島県"},
      {"value": "沖縄県", "label": "沖縄県"}
    ],
    placeholder: "都道府県を選択してください",
    required: true,
  },
  city: {
    name: "市区郡",
    type: "text",
    placeholder: "例) 福岡市博多区",
    required: true,
  },
  townAndNumber: {
    name: "町村字番地",
    type: "text",
    placeholder: "例) 博多駅中央街8-1",
    required: true,
  },
  building: {
    name: "建物名及び部屋番号等",
    type: "text",
    placeholder: "例) ＪＲＪＰ博多ビル8階",
    required: false,
  },
  tel: {
    name: "電話番号(ハイフン抜き)",
    type: "text",
    placeholder: "例) 0000000000",
    required: true,
    pattern: /^\d{10}\d?$/,
  },
  email: {
    name: "メールアドレス",
    type: "text",
    placeholder: "例) sample@example.com",
    required: true,
    pattern: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
  },
  password: {
    name: "パスワード",
    type: "password",
    placeholder: "パスワードを入力",
    required: true,
    caution: "英数字混合かつ英字の大文字小文字が混在する8文字以上にしてください",
    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+/,
    invalidMsg: "パスワードは英数字混合かつ英字の大文字小文字が混在する8文字以上で入力してください",
  }, 
  passwordConfirm: {
    name: "パスワード(確認用)",
    type: "password",
    placeholder: "パスワードをもう一度入力",
    required: true,
  },
}
